import React from "react";
import { useSidebar } from "../context/useSidebar";

export default function FindX() {
  const { isSidebarOpen } = useSidebar();
  const containerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    width: "100%",
  };

  const imgStyle = {
    maxWidth: "100%",
    height: "auto",
  };

  return (
    <div className={`content-body d-flex bg-black max-h-full ${isSidebarOpen ? "sidebar-open-page-margin" : "sidebar-close-page-margin"}`} style={containerStyle}>
      <img src="assets/images/pages/findXComingSoon.jpeg" alt="bunswap" style={imgStyle} />
    </div>
  );
}
